import { useIntl } from "react-intl";
import {
  ACCOUNT_CREATION_ROUTE,
  CONSUMER_ACCOUNT_CREATION,
  LINEAR_PROGRESS_LABEL,
  PREFERRED_VERIFICATION_PAGE,
  PROVIDER_ACCOUNT_CREATION,
  PROVIDER_REVIEW_INFO,
  REVIEW_APPLICATION_ROUTE,
  LOG_IN,
  LOGIN_ROUTE,
  ENABLE_ACCOUNT_ROUTE,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_ROUTE,
  ENABLE_ACCOUNT,
  MANAGE_VERIFICATION_METHOD,
  BASE_ROUTE,
  LOGIN_VERIFICATION_METHOD_ROUTE,
  SECURITY_PREFERENCES_ROUTE,
  MY_PROFILE_ACCOUNT_SETTINGS_ROUTE,
} from "../../Constants/CommonConstants";
import {
  ADD_OR_EDIT_VERIFICATION,
  VERIFY_ACCOUNT_BACK_BUTTON,
  VERIFY_ACCOUNT_BACK_BUTTON_ID,
} from "../../Constants/VerifyAccountConstants";
import { StyledVerifyAccountBackBox } from "../../Styles/Login/VerifyAccount/VerifyAccountStyles";
import { PrimaryLinearProgress, BackButton } from "react-common-ui-library";
import { useNavigate } from "react-router";
import PropTypes from "prop-types";

/**
 * @description Displays the Progress Bar and back button for consumer account creation flow or only back button for Login, enable account and forgot password flow                                       flow
 * @param {string} previousScreen specifies the previous screen for verify account
 * @returns {ReactNode} Renders the progress bar and back button display for verify account page
 */
export const VerifyAccountProgressAndBackBtn = ({
  previousScreen,
  selectedVerificationMethod,
  method,
}) => {
  const intl = useIntl();
  const navigate = useNavigate();

  const backButtonClickHandler = () => {
    switch (previousScreen) {
      case CONSUMER_ACCOUNT_CREATION:
        navigate(`/${ACCOUNT_CREATION_ROUTE}/${REVIEW_APPLICATION_ROUTE}`);
        break;
      case PROVIDER_ACCOUNT_CREATION:
        navigate(`/${ACCOUNT_CREATION_ROUTE}/${PROVIDER_REVIEW_INFO}`);
        break;
      case LOG_IN:
        navigate(`${BASE_ROUTE}${LOGIN_ROUTE}`);
        break;
      case ENABLE_ACCOUNT:
        navigate(`/${LOGIN_ROUTE}/${ENABLE_ACCOUNT_ROUTE}`);
        break;
      case FORGOT_PASSWORD:
        navigate(`${BASE_ROUTE}${FORGOT_PASSWORD_ROUTE}`);
        break;
      case ADD_OR_EDIT_VERIFICATION:
        navigate(`/${LOGIN_ROUTE}/${MANAGE_VERIFICATION_METHOD}`, {
          state: {
            flow: selectedVerificationMethod,
            previousScreen: LOGIN_VERIFICATION_METHOD_ROUTE,
            method: method,
          },
        });
        break;
      case SECURITY_PREFERENCES_ROUTE:
        navigate(
          `/${MY_PROFILE_ACCOUNT_SETTINGS_ROUTE}/${MANAGE_VERIFICATION_METHOD}`,
          {
            state: {
              flow: selectedVerificationMethod,
              previousScreen: SECURITY_PREFERENCES_ROUTE,
              method: method,
            },
          }
        );
        break;
      default:
        break;
    }
  };

  return (
    <>
      {previousScreen === CONSUMER_ACCOUNT_CREATION ? (
        <PrimaryLinearProgress
          progressValue={100}
          backButtonOnClickHandler={backButtonClickHandler}
          backButtonText={VERIFY_ACCOUNT_BACK_BUTTON}
          progressLabel={LINEAR_PROGRESS_LABEL}
          currentPage={PREFERRED_VERIFICATION_PAGE}
        />
      ) : (
        <StyledVerifyAccountBackBox>
          <BackButton
            backButtonOnClickHandler={backButtonClickHandler}
            id={VERIFY_ACCOUNT_BACK_BUTTON_ID}
            backButtonText={intl.formatMessage({
              id: VERIFY_ACCOUNT_BACK_BUTTON,
            })}
          />
        </StyledVerifyAccountBackBox>
      )}
    </>
  );
};

VerifyAccountProgressAndBackBtn.propTypes = {
  /**
   * specifies the previous screen
   */
  previousScreen: PropTypes.string.isRequired,
  /**
   * specifies the selected verification screen
   */
  selectedVerificationMethod: PropTypes.string.isRequired,
  /**
   * specifies the selected verification method (add/edit)
   */
  method: PropTypes.string.isRequired,
};
